import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { JiraCredential } from 'src/app/models/JiraCredentials';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root',
})
export class JiraLoginService {
    httpOptions = {};

    constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) {
        this.httpOptions = authenticationService.getHeaders();
    }

    checkIfJiraCredentialsExistAndFetch() {
        return this.httpClient.get<JiraCredential>(environment.baseUrl + '/jira/credentialsExist', this.httpOptions);
    }

    pushJiraCredentials(jiraCredential: JiraCredential) {
        return this.httpClient.post<boolean>(
            environment.baseUrl +
                `/jira/addCredentials?username=${jiraCredential.username}&apiKey=${jiraCredential.apiKey}&tempoKey=${jiraCredential.tempoKey}`,
            {},
            this.httpOptions,
        );
    }

    removeJiraCredentials() {
        return this.httpClient.post<boolean>(environment.baseUrl + `/jira/removeCredentials`, '', this.httpOptions);
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    getJiraProjectKeys(): Observable<Object[]> {
        return this.httpClient.get<Map<string, string>[]>(environment.baseUrl + `/jira/projectKeyList`, this.httpOptions);
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    getJiraEmployeeIDs(): Observable<Object[]> {
        return this.httpClient.get<Map<string, string>[]>(environment.baseUrl + `/jira/employeeIdList`, this.httpOptions);
    }

    // TODO This has to be refactored as the backend now only accepts a projectId, which is numeric in stead of a string
    getTempoTimeSheetsForProjects(projectKey: string) {
        return this.httpClient.get<any>(environment.baseUrl + `/jira/tempoTimesheetsForProject/${projectKey}`, this.httpOptions);
    }

    importAllTempoTimeSheets(month: number, year: number): Observable<boolean> {
        return this.httpClient.post<boolean>(`${environment.baseUrl}/jira/importFromJira?month=${month}&year=${year}`, null, this.httpOptions);
    }

    // Tempo accounts by project (via backend)
    getTempoAccountLinksForProject(projectId: string | number) {
        return this.httpClient.get<any>(`${environment.baseUrl}/jira/tempo/account-links/project/${projectId}`, this.httpOptions);
    }

    getTempoAccountDetails(accountId: string | number) {
        return this.httpClient.get<any>(`${environment.baseUrl}/jira/tempo/accounts/${accountId}`, this.httpOptions);
    }

    // Tempo accounts: direct frontend calls (no backend dependency)
    getTempoAccountLinksForProjectDirect(projectId: string | number, tempoKey: string) {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${tempoKey}`,
            'Content-Type': 'application/json'
        });
        return this.httpClient.get<any>(`https://api.tempo.io/4/account-links/project/${projectId}?limit=5000`, { headers });
    }

    getTempoAccountDetailsDirect(accountId: string | number, tempoKey: string) {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${tempoKey}`,
            'Content-Type': 'application/json'
        });
        return this.httpClient.get<any>(`https://api.tempo.io/4/accounts/${accountId}`, { headers });
    }

    // Tempo worklogs by account (via backend)
    getTempoWorklogsByAccount(accountKey: string, from?: string, to?: string, limit: number = 1000) {
        const params = [] as string[];
        if (from) params.push(`from=${from}`);
        if (to) params.push(`to=${to}`);
        if (limit) params.push(`limit=${limit}`);
        const qs = params.length ? `?${params.join('&')}` : '';
        return this.httpClient.get<any>(`${environment.baseUrl}/jira/tempo/worklogs/account/${encodeURIComponent(accountKey)}${qs}`, this.httpOptions);
    }

    // Jira issue details (via backend)
    getJiraIssueDetails(issueId: string) {
        return this.httpClient.get<any>(`${environment.baseUrl}/jira/issue/${issueId}`, this.httpOptions);
    }
}
